import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-requerimentos',
  templateUrl: './form-requerimentos.component.html',
  styleUrls: ['./form-requerimentos.component.css']
})
export class FormRequerimentosComponent implements OnInit {

  tipo =  []

  constructor() { 
    this.tipo[0] = "Imposto de Renda"
  }

  ngOnInit(): void {
    this.tipo[0] = "Imposto de Renda"
  }

}
